<script>
    export let hideMenu = false

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'
    const windowLocationPath = window.location.pathname
</script>

<nav class="navbar navbar-inverse navbar-static-top">
    <div class="container-fluid">
        <div class="navbar-header">
            { #if !hideMenu }
                <button
                    type="button"
                    data-toggle="collapse"
                    data-target="#responsiveMenu"
                    class="navbar-toggle collapsed"
                >
                    <span class="sr-only">Toggle Navigation</span>
                    <span class="icon-bar" />
                    <span class="icon-bar" />
                    <span class="icon-bar" />
                </button>
            {/if}
            <a href={windowLocationPath} style="padding-top: 10px; padding-left: 8px;" class="navbar-brand"><img
                    alt="Logo of From Now On."
                    src="{staticAssetPrefix}img/fromnowon-logo-03.png"
                    height="44"
                    border="0"
                /></a>
        </div>
        <slot />
    </div>
</nav>
